/** Class-name join. Tiny enough that a dependency would cost more than it saves. */
export function clsx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
